var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgsprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426.667,
    height: 5947.267,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 23 21",
    id: "arrow-icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M79.25 100.387L72.964 100.387 72.964 91.156 63.536 91.156 63.536 100.387 57.25 100.387 68.25 111.156z",
    transform: "translate(-57 -91)"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    fill: "white",
    viewBox: "0 0 25 30",
    id: "checkmark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 400 400",
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 140l-19 19 41 41-41 41 19 19 41-41 41 41 19-19-41-41 41-41-19-19-41 41z",
    fill: "#bcbcbc"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 50 50",
    id: "contract-select"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "contract-select_a",
    d: "M49.418 17.525l-23.022 22.99a1.966 1.966 0 0 1-2.792 0L.582 17.526a2.004 2.004 0 0 1 0-2.824l5.15-5.12a1.966 1.966 0 0 1 2.793 0L25 26.058 41.475 9.582a1.966 1.966 0 0 1 2.793 0l5.15 5.12a2.004 2.004 0 0 1 0 2.823z"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#242424",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 0 50.097)",
    xlinkHref: "#contract-select_a"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "exclamation"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "exclamation_prefix__a",
    d: "M11.429 15.403v-2.12c0-.201-.157-.369-.358-.369H8.93c-.201 0-.358.168-.358.369v2.12c0 .201.157.368.358.368h2.142c.201 0 .358-.167.358-.368zm-.023-4.174l.201-5.123c0-.067-.033-.156-.111-.212-.067-.056-.168-.123-.268-.123H8.772c-.1 0-.2.067-.268.123-.078.056-.111.168-.111.235l.19 5.1c0 .145.167.257.38.257h2.064c.2 0 .368-.112.38-.257zM11.25.805l8.571 15.714c.246.435.235.971-.022 1.406-.257.436-.725.704-1.228.704H1.43c-.503 0-.971-.268-1.228-.704-.257-.435-.268-.97-.022-1.406L8.75.805C8.996.347 9.475.057 10 .057s1.004.29 1.25.748z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "exclamation_prefix__b",
    d: "M11.429 15.403v-2.12c0-.201-.157-.369-.358-.369H8.93c-.201 0-.358.168-.358.369v2.12c0 .201.157.368.358.368h2.142c.201 0 .358-.167.358-.368zm-.023-4.174l.201-5.123c0-.067-.033-.156-.111-.212-.067-.056-.168-.123-.268-.123H8.772c-.1 0-.2.067-.268.123-.078.056-.111.168-.111.235l.19 5.1c0 .145.167.257.38.257h2.064c.2 0 .368-.112.38-.257zM11.25.805l8.571 15.714c.246.435.235.971-.022 1.406-.257.436-.725.704-1.228.704H1.43c-.503 0-.971-.268-1.228-.704-.257-.435-.268-.97-.022-1.406L8.75.805C8.996.347 9.475.057 10 .057s1.004.29 1.25.748z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#242424",
    xlinkHref: "#exclamation_prefix__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EA001C",
    xlinkHref: "#exclamation_prefix__b"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 50 50",
    id: "expand-select"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "expand-select_a",
    d: "M49.418 17.525l-23.022 22.99a1.966 1.966 0 0 1-2.792 0L.582 17.526a2.004 2.004 0 0 1 0-2.824l5.15-5.12a1.966 1.966 0 0 1 2.793 0L25 26.058 41.475 9.582a1.966 1.966 0 0 1 2.793 0l5.15 5.12a2.004 2.004 0 0 1 0 2.823z"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#242424",
    fillRule: "evenodd",
    xlinkHref: "#expand-select_a"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-check .st0 {\r\n          fill-rule: evenodd;\r\n          clip-rule: evenodd;\r\n          fill: #07a200;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("path", {
    id: "icon-check_icon",
    className: "st0",
    d: "M24.7,11.7c0-0.3-0.1-0.7-0.3-0.9L22.6,9c-0.2-0.2-0.5-0.4-0.9-0.4S21.1,8.8,20.9,9L13,16.9l-4.4-4.4 c-0.2-0.2-0.5-0.4-0.9-0.4c-0.3,0-0.6,0.1-0.9,0.4l-1.8,1.7c-0.2,0.2-0.3,0.6-0.3,0.9c0,0.3,0.1,0.6,0.3,0.9l7,7 c0.2,0.2,0.6,0.4,0.9,0.4c0.3,0,0.7-0.1,0.9-0.4l10.5-10.5C24.6,12.3,24.7,12,24.7,11.7z M29.6,14.8c0,8.2-6.6,14.8-14.8,14.8 S0,22.9,0,14.8S6.6,0,14.8,0S29.6,6.6,29.6,14.8z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 60",
    id: "icon-corner-rounded"
  }, /*#__PURE__*/React.createElement("title", null, "icon_corner_rounded"), /*#__PURE__*/React.createElement("g", {
    id: "icon-corner-rounded_icon_corner_rounded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-corner-rounded_icon_shape_rectangle_smooth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.66171,0 C47.9553903,1.34328358 36.5799257,0.671641791 27.4349442,1.34328358 C19.8513011,1.79104478 13.605948,5.14925373 9.14498141,9.85074627 C1.56133829,17.9104478 0.892193309,30.4477612 0.669144981,40.5223881 C0.446096654,47.6865672 3.33066907e-15,53.9552239 0.223048327,54.4029851 L0.223048327,60 L1.56133829,60 L1.56133829,60 L58.8847584,60 C59.5539033,60 60,59.5522388 60,58.880597 C60,58.880597 60,58.880597 60,58.880597 L60,0 L58.66171,0 Z",
    id: "icon-corner-rounded_Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66171,1.11940299 L58.66171,59.1044776 L1.33828996,59.1044776",
    id: "icon-corner-rounded_Path",
    stroke: "#BABABA",
    strokeWidth: 2.23048327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.60594821064889,7.070632140432591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7769517,2.23880597 C59.7769517,2.23880597 45.0557621,2.23880597 29.8884758,2.23880597 C17.1747212,2.46268657 2.4535316,14.5522388 2.4535316,30 C2.4535316,44.1044776 2.23048327,60 2.23048327,60 L0,60 C0,60 0,38.7313433 0,30 C0,14.1044776 13.3828996,0 29.6654275,0 C48.8475836,0 59.5539033,0 59.5539033,0 L59.7769517,2.23880597 Z",
    id: "icon-corner-rounded_Path",
    fill: "#505050",
    fillRule: "nonzero"
  }))))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 60",
    id: "icon-corner-scalloped"
  }, /*#__PURE__*/React.createElement("title", null, "icon_corner_scalloped"), /*#__PURE__*/React.createElement("g", {
    id: "icon-corner-scalloped_icon_corner_scalloped",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-corner-scalloped_icon_shape_rectangle_scallop_none",
    transform: "translate(0, -0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3257721,0 C30.0276086,0 29.7418723,0.119439191 29.5321031,0.331285184 L29.0926287,0.773931435 C28.8940219,0.973852331 28.7777521,1.24105208 28.7668459,1.52261357 C28.2687398,16.4086183 16.4002262,28.4063645 1.51737322,29.0687975 C1.23284447,29.0787558 0.962929367,29.1972599 0.763064182,29.3999708 L0.323589781,29.8437363 C0.115940704,30.0529832 0,30.335913 0,30.6306729 L0,60 L58.880548,60 C59.1774979,60 59.462335,59.8823114 59.6723103,59.6723821 C59.8822856,59.4624527 60,59.177678 60,58.8807931 L60,0 L30.3257721,0 Z",
    id: "icon-corner-scalloped_Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.880548,1.11996776 L58.880548,58.8799873 L1.32281249,58.8799873",
    id: "icon-corner-scalloped_Path",
    stroke: "#BABABA",
    strokeWidth: 2.23890367,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: 10.6459871961146
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8803465,1.11896048 L30.3253691,1.11896048 L29.8871037,1.56180819 C29.4320908,17.0617393 17.0573065,29.5663905 1.55971089,30.1864821 L1.12025887,30.6304938 L1.12025887,58.8809946",
    id: "icon-corner-scalloped_Path",
    stroke: "#505050",
    strokeWidth: 2.23890367,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 60",
    id: "icon-corner-squared"
  }, /*#__PURE__*/React.createElement("title", null, "icon_corner_squared"), /*#__PURE__*/React.createElement("g", {
    id: "icon-corner-squared_icon_corner_squared",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-corner-squared_icon_shape_rectangle_squared"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.223880597 L0.223048327,60 L1.56133829,60 L58.8847584,60 C59.5539033,60 60,59.5522388 60,58.880597 L60,58.880597 L60,0 L0,0.223880597 Z",
    id: "icon-corner-squared_Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66171,1.11940299 L58.66171,59.1044776 L1.33828996,59.1044776",
    id: "icon-corner-squared_Path",
    stroke: "#BABABA",
    strokeWidth: 2.23048327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.6059482106489,7.070632140432598"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "icon-corner-squared_Path",
    fill: "#505050",
    fillRule: "nonzero",
    points: "59.7769517 2.23880597 2.23048327 2.23880597 2.23048327 60 0 60 0 0 59.7769517 0"
  }))))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 36 36",
    id: "icon-easy-apply-design"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-easy-apply-design .st0 {\r\n          fill: #505050;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("g", {
    id: "icon-easy-apply-design_Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-easy-apply-design_Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.13123,14.00977c1.78894,0,3.02747-1.23853,3.02747-3.02753c0-1.65137-1.3761-3.02747-3.02747-3.02747 S6.1037,9.33087,6.1037,10.98224S7.47986,14.00977,9.13123,14.00977z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.40881,21.11426h0.07361V3.74023H2.4043v25.01953h19.82861 c1.03674,1.68481,2.87537,2.75006,4.86969,2.75006c3.16699,0,5.74316-2.57617,5.74316-5.74219 C32.84576,23.91522,31.92004,22.18677,30.40881,21.11426z M3.9043,5.24023h25.07812v15.12244 c-0.61005-0.22028-1.23834-0.3382-1.87982-0.3382c-0.44055,0-0.86786,0.05457-1.28021,0.14899l-5.54492-7.63739 c-0.13763-0.13763-0.41284-0.27527-0.55048-0.27527c-0.27521,0-0.41284,0.13763-0.55042,0.27527l-4.67889,5.77972 l-2.75226-1.92657c-0.27521-0.13763-0.55042-0.13763-0.82568,0.13757l-5.09167,6.19263 c-0.13757,0.13757-0.27521,0.41284-0.13757,0.68805c0.13757,0.27521,0.27521,0.41284,0.55042,0.41284h15.46661 c-0.22052,0.60913-0.34711,1.26294-0.34711,1.94733c0,0.50378,0.0882,1.00128,0.22504,1.49213H3.9043V5.24023z M30.40045,23.77838 l-3.75879,4.81348c-0.11719,0.14844-0.29102,0.24219-0.47949,0.25781c-0.01855,0.00195-0.03711,0.00293-0.05566,0.00293 c-0.16992,0-0.33398-0.06348-0.45898-0.17969l-1.76562-1.62402c-0.27637-0.25293-0.29395-0.68262-0.04004-0.95801 c0.25293-0.27637,0.68359-0.29395,0.95801-0.04004l1.22461,1.12598l3.30566-4.23438 c0.23047-0.29492,0.65918-0.34668,0.95312-0.11719C30.57819,23.0567,30.63092,23.48248,30.40045,23.77838z"
  }))))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edge-scalloped",
    viewBox: "0 0 100.7 100.8"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-edge-scalloped .st0 {\r\n          fill: none;\r\n          stroke: #505050;\r\n          strokewidth: 3;\r\n          stroke-miterlimit: 10;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.43023,89.64731c-2.8,0-5.4-1.3-7.1-3.6c-4.3,2.4-9.8,0.9-12.3-3.4c-0.4-0.7-0.7-1.4-0.9-2.1 c-2.8,0.4-5.6-0.6-7.5-2.6c-1.9-1.9-2.8-4.6-2.4-7.3c-2.7-0.7-4.9-2.7-5.9-5.2c-1.1-2.6-0.9-5.5,0.5-7.9c-2.2-1.7-3.5-4.3-3.6-7.1 c0-2.8,1.3-5.4,3.6-7.1c-1.4-2.5-1.5-5.4-0.4-8c1-2.5,3.2-4.4,5.8-5.2c-0.6-4.9,3-9.4,7.9-9.9c0.7-0.1,1.4-0.1,2,0 c0.7-2.8,2.7-5,5.3-6.1c2.6-1,5.4-0.8,7.8,0.6c1.7-2.2,4.3-3.5,7.1-3.6l0,0c2.8,0,5.4,1.3,7.1,3.6c2.4-1.4,5.3-1.6,7.90001-0.5 c2.6,1.1,4.6,3.3,5.3,6c2.8-0.3,5.6,0.6,7.6,2.6c1.8,1.9,2.7,4.6,2.4,7.3c4.8,1.3,7.6,6.3,6.3,11.1c-0.2,0.7-0.5,1.5-0.9,2.1 c3.9,3.1,4.6,8.8,1.5,12.7c-0.4,0.6-0.9,1-1.5,1.5c2.5,4.3,1,9.8-3.3,12.3c-0.7,0.4-1.3,0.7-2.1,0.9c0.6,4.9-2.9,9.5-7.8,10.1 c-0.7,0.1-1.5,0.1-2.2,0c-1.4,4.8-6.3,7.6-11.1,6.2c-0.7-0.2-1.4-0.5-2-0.9C55.83023,88.44731,53.23024,89.74731,50.43023,89.64731 L50.43023,89.64731z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edge-smooth",
    viewBox: "0 0 100.7 100.8"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-edge-smooth .st0 {\r\n          fill: none;\r\n          stroke: #505050;\r\n          strokewidth: 3;\r\n          stroke-miterlimit: 10;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.35,14.4L50.35,14.4c-19.9,0-36,16.2-36,36l0,0c0,19.9,16.2,36,36,36l0,0c19.9,0,36-16.2,36-36l0,0 C86.35,30.6,70.35,14.4,50.35,14.4z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-envelope",
    viewBox: "0 0 30 24"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-envelope .st0 {\r\n          fill-rule: evenodd;\r\n          clip-rule: evenodd;\r\n          fill: #b9b9b9;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,7.8v13.3c0,1.5-1.2,2.7-2.7,2.7H2.7c-1.5,0-2.7-1.2-2.7-2.7V7.8c0.5,0.6,1.1,1,1.7,1.5 C4.5,11.1,7.3,13,10,15c1.4,1,3.1,2.3,5,2.3h0c1.8,0,3.6-1.3,5-2.3c2.7-2,5.5-3.9,8.3-5.8C28.9,8.8,29.5,8.3,30,7.8z M30,2.8 c0,1.9-1.4,3.6-2.9,4.6c-2.6,1.8-5.2,3.6-7.8,5.4c-1.1,0.8-2.9,2.3-4.3,2.3h0c-1.4,0-3.2-1.5-4.3-2.3c-2.6-1.8-5.2-3.6-7.8-5.4 C1.7,6.6,0,4.7,0,3.2c0-1.6,0.9-3,2.7-3h24.6C28.8,0.2,30,1.4,30,2.8z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 36 36",
    id: "icon-join-newsletter"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-join-newsletter .st0 {\r\n          fill: #505050;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("g", {
    id: "icon-join-newsletter_Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-join-newsletter_Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.31152,9.617V2.82129H8.68848V9.3457l-6.12549,4.47266v19.36035H33.4375V13.80322L27.31152,9.617z  M14.15247,23.49854L4.06299,31.18958V15.80676L14.15247,23.49854z M15.88483,24.06445h4.22943l9.98914,7.61426H5.89606 L15.88483,24.06445z M21.79834,23.46106l10.13916-7.73004v15.45862L21.79834,23.46106z M31.41809,14.24017l-4.10657,3.13068 v-5.93744L31.41809,14.24017z M25.81152,4.32129V18.5144l-5.31256,4.05005h-5.09723l-5.21326-3.97437V4.32129H25.81152z  M8.68848,17.44659l-4.18341-3.18927l4.18341-3.05383V17.44659z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.53467,
    y: 8.50391,
    className: "st0",
    width: 8.93018,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.53467,
    y: 12.41553,
    className: "st0",
    width: 8.93018,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.53467,
    y: 16.32764,
    className: "st0",
    width: 8.93018,
    height: 1.5
  }))))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lock",
    viewBox: "0 0 25 30"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-lock .st0 {\r\n          fill-rule: evenodd;\r\n          clip-rule: evenodd;\r\n          fill: #b9b9b9;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.8,13.6h10.9V9.5c0-3-2.5-5.5-5.5-5.5S6.8,6.5,6.8,9.5V13.6z M24.5,15.7V28c0,1.1-0.9,2-2,2H2 c-1.1,0-2-0.9-2-2V15.7c0-1.1,0.9-2,2-2h0.7V9.5C2.7,4.3,7,0,12.3,0s9.5,4.3,9.5,9.5v4.1h0.7C23.6,13.6,24.5,14.6,24.5,15.7z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-save-project",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        #icon-save-project .st0 {\r\n          fill: #505050;\r\n        }\r\n      "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.02539,4.31592H4.31592v27.36768h27.36768V9.05322L27.02539,4.31592z M22.8064,8.93463v2.02258h-4.11523 V8.93463H22.8064z M30.18359,30.18359H5.81592V5.81592h5.20074v7.05341h13.96667V5.81592h1.41315l3.78711,3.85156V30.18359z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.01953,26.71094 10.51953,26.71094 10.51953,20.72754 25.48047,20.72754 25.48047,26.71094  26.98047,26.71094 26.98047,19.22754 9.01953,19.22754  "
  })))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 426.667 426.667",
    id: "image-not-available"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.333 0C95.514 0 0 95.514 0 213.333s95.514 213.333 213.333 213.333 213.333-95.514 213.333-213.333S331.153 0 213.333 0zm117.662 276.689l-54.302 54.306-63.36-63.356-63.36 63.36-54.302-54.31 63.356-63.356-63.356-63.36 54.302-54.302 63.36 63.356 63.36-63.356 54.302 54.302-63.356 63.36 63.356 63.356z",
    fill: "#f05228"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 14",
    id: "info-circle"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1464E4",
    fillRule: "evenodd",
    d: "M9.333 11.375V9.917c0-.164-.127-.292-.291-.292h-.875V4.958c0-.164-.128-.291-.292-.291H4.958c-.164 0-.291.127-.291.291v1.459c0 .164.127.291.291.291h.875v2.917h-.875c-.164 0-.291.128-.291.292v1.458c0 .164.127.292.291.292h4.084c.164 0 .291-.128.291-.292zM8.167 3.208V1.75c0-.164-.128-.292-.292-.292h-1.75c-.164 0-.292.128-.292.292v1.458c0 .164.128.292.292.292h1.75c.164 0 .292-.128.292-.292zM14 7c0 3.865-3.135 7-7 7s-7-3.135-7-7 3.135-7 7-7 7 3.135 7 7z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "label"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.096 30.5V32h-5v-1.5h5zm7.987 0 .015 1.5h-5.002v-1.5h4.986zm-19.33-2.14a7.48 7.48 0 0 0 3.668 1.974L7.106 31.8a8.981 8.981 0 0 1-4.402-2.369l1.05-1.072zm25.153-.737 1.18.926a9.02 9.02 0 0 1-4.053 2.927l-.505-1.412a7.52 7.52 0 0 0 3.378-2.44zM22 3a7 7 0 0 1 7 7v12a7 7 0 0 1-7 7H10a7 7 0 0 1-7-7V10a7 7 0 0 1 7-7h12zM1.5 22.145V23c0 1.163.264 2.285.764 3.303l-1.345.663A8.963 8.963 0 0 1 0 23v-.856h1.5zM22 5.5H10A4.5 4.5 0 0 0 5.5 10v12a4.5 4.5 0 0 0 4.5 4.5h12a4.5 4.5 0 0 0 4.5-4.5V10A4.5 4.5 0 0 0 22 5.5zm10 15.451V23c0 1.02-.17 2-.482 2.913l-1.419-.486c.264-.774.401-1.59.401-2.427v-2.048l1.5-.001zM1.5 14.145v5L0 19.144v-5h1.5zM32 12.95v5h-1.5v-5H32zM.45 6.179l1.425.47A7.492 7.492 0 0 0 1.5 9v2.145L0 11.144V9c0-.985.158-1.934.45-2.82zm30.675-1.055A8.965 8.965 0 0 1 32 9v.951h-1.5V9c0-1.134-.251-2.23-.728-3.229l1.353-.647zM5.875.557l.52 1.407a7.523 7.523 0 0 0-3.351 2.477l-1.19-.913A9.023 9.023 0 0 1 5.875.558zM24.988.22a8.985 8.985 0 0 1 4.377 2.417l-1.061 1.06c-1-1-2.262-1.701-3.646-2.013l.33-1.464zM8.995 0l.002 1.5c-.054 0-.108 0-.161.002l-.033-1.5L8.995 0zM14 0v1.5H9V0h5zm8 0v1.5h-5V0h5z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.404
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 38 38",
    stroke: "#DDD",
    id: "loading"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.5,
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
  }))))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 20",
    id: "locked-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.992H12v-3.99C12 1.793 10.21 0 8 0S4 1.792 4 4.003v3.99H2.5c-1.38 0-2.499 1.12-2.5 2.501v7.004c.001 1.381 1.12 2.5 2.5 2.502h11c1.38-.001 2.499-1.12 2.5-2.502v-7.004c-.001-1.381-1.12-2.5-2.5-2.502zm-8.3-3.99c-.007-1.005.526-1.936 1.395-2.44.869-.505 1.941-.505 2.81 0 .87.504 1.402 1.435 1.396 2.44v3.99H5.199v-3.99zm3.3 11.495c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-3.002c0-.276.224-.5.5-.5s.5.224.5.5v3.002z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 400 440",
    id: "minus-icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394,154.174c-5.331-5.33-11.806-7.995-19.417-7.995H27.406c-7.611,0-14.084,2.665-19.414,7.995 C2.662,159.503,0,165.972,0,173.587v54.82c0,7.617,2.662,14.086,7.992,19.41c5.33,5.332,11.803,7.994,19.414,7.994h347.176 c7.611,0,14.086-2.662,19.417-7.994c5.325-5.324,7.991-11.793,7.991-19.41v-54.82C401.991,165.972,399.332,159.5,394,154.174z",
    fill: "#ffffff"
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 533.333 533.333",
    id: "plus-icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M516.667,200H333.333V16.667C333.333,7.462,325.871,0,316.667,0h-100C207.462,0,200,7.462,200,16.667V200H16.667   C7.462,200,0,207.462,0,216.667v100c0,9.204,7.462,16.666,16.667,16.666H200v183.334c0,9.204,7.462,16.666,16.667,16.666h100   c9.204,0,16.667-7.462,16.667-16.666V333.333h183.333c9.204,0,16.667-7.462,16.667-16.666v-100   C533.333,207.462,525.871,200,516.667,200z",
    fill: "#ffffff"
  })))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "position"
  }, /*#__PURE__*/React.createElement("g", {
    id: "position_Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "position_Artboard",
    transform: "translate(-61, -15)",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.404
  }, /*#__PURE__*/React.createElement("g", {
    id: "position_iconmonstr-cursor-23",
    transform: "translate(61, 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,13.3333333 C17.472,13.3333333 18.6666667,14.528 18.6666667,16 C18.6666667,17.472 17.472,18.6666667 16,18.6666667 C14.528,18.6666667 13.3333333,17.472 13.3333333,16 C13.3333333,14.528 14.528,13.3333333 16,13.3333333 Z M10.8573333,17.3333333 C10.7453333,16.9053333 10.6666667,16.464 10.6666667,16 C10.6666667,15.536 10.7453333,15.0946667 10.8573333,14.6666667 L8,14.6666667 L8,9.33333333 L0,16 L8,22.6666667 L8,17.3333333 L10.8573333,17.3333333 Z M21.1426667,14.6666667 C21.2546667,15.0946667 21.3333333,15.536 21.3333333,16 C21.3333333,16.464 21.2546667,16.9053333 21.1426667,17.3333333 L24,17.3333333 L24,22.6666667 L32,16 L24,9.33333333 L24,14.6666667 L21.1426667,14.6666667 Z M17.3333333,21.1426667 C16.9053333,21.2546667 16.464,21.3333333 16,21.3333333 C15.536,21.3333333 15.0946667,21.2546667 14.6666667,21.1426667 L14.6666667,24 L9.33333333,24 L16,32 L22.6666667,24 L17.3333333,24 L17.3333333,21.1426667 Z M14.6666667,10.8573333 C15.0946667,10.7453333 15.536,10.6666667 16,10.6666667 C16.464,10.6666667 16.9053333,10.7453333 17.3333333,10.8573333 L17.3333333,8 L22.6666667,8 L16,0 L9.33333333,8 L14.6666667,8 L14.6666667,10.8573333 Z",
    id: "position_Shape"
  })))))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "redo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11 3.49a7.15 7.15 0 0 1 9 .23l.11.1L15 2v6.12H9.11l1.64-1.71a3.84 3.84 0 0 0-2.27-.75 4.11 4.11 0 0 0-4 4.22 4.35 4.35 0 0 0 .68 2.36l.1.14-.75.75-1.79 1.76A8.1 8.1 0 0 1 1 9.87a8 8 0 0 1 3.11-6.38z",
    fill: "#052562",
    fillRule: "evenodd"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "redo-disabled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11 3.49a7.15 7.15 0 0 1 9 .23l.11.1L15 2v6.12H9.11l1.64-1.71a3.84 3.84 0 0 0-2.27-.75 4.11 4.11 0 0 0-4 4.22 4.35 4.35 0 0 0 .68 2.36l.1.14-.75.75-1.79 1.76A8.1 8.1 0 0 1 1 9.87a8 8 0 0 1 3.11-6.38z",
    fill: "#CACED5",
    fillRule: "evenodd"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "-11 -11 44 44",
    id: "resize"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9 15.037h-1.783a.625.625 0 0 0-.625.625.625.625 0 0 0 .625.625h3.32a.606.606 0 0 0 .606-.606v-3.32a.624.624 0 0 0-.624-.625.625.625 0 0 0-.625.625v1.782l-2.308-2.307a.632.632 0 0 0-.894.894l2.307 2.307zM7.762 7.258h1.783a.625.625 0 0 0 .624-.625.625.625 0 0 0-.624-.624h-3.32a.606.606 0 0 0-.606.606v3.32a.625.625 0 0 0 .624.624.625.625 0 0 0 .625-.624V8.153l2.307 2.307a.632.632 0 1 0 .894-.894L7.763 7.257z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 35 37",
    id: "rotate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25,15.75C4.5,-3,31.5,-3,34.5,15.75C31.5,-3,4.5,-3,2.25,15.75M34.5,21.75C31.5,39.75,4.5,39.75,2.25,21.75C4.5,39.75,31.5,39.75,34.5,21.75M1.5,17.25C1.5,17.25,0.75,11.25,0.75,11.25C0.75,11.25,5.25,12.75,5.25,12.75C5.25,12.75,1.5,17.25,1.5,17.25M18.375,13.5C14.33365121715164,13.528867779675956,11.83905817023386,17.92179853381868,13.884732792208268,21.407275355480703C15.930407414182675,24.89275217714273,20.982093392743124,24.856667452547782,22.977767553617074,21.342322851209808C24.957015181363438,17.856905065254544,22.458084159312556,13.5286301669692,18.450000000000003,13.5M34.5,21.75C34.5,21.75,35.25,27.75,35.25,27.75C35.25,27.75,30,26.25,30,26.25C30,26.25,34.5,21.75,34.5,21.75",
    id: "rotate_dpo8-id-15-rotation",
    fill: "#000000",
    stroke: "#000000",
    style: {
      strokeWidth: 2
    },
    className: "",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 28 25",
    id: "rotate-icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M23.348 19.35c-.308.462-.809.46-1.115 0l-4.652-6.977h3.256c0-4.668-3.797-8.466-8.465-8.466-4.667 0-8.465 3.798-8.465 8.466 0 4.667 3.798 8.465 8.465 8.465v3.907C5.551 24.745 0 19.195 0 12.373S5.55 0 12.372 0s12.372 5.55 12.372 12.373H28l-4.652 6.978z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "rotate-image-icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.476 0C.664 0 0 .69 0 1.533v.313h.667v-.313c0-.472.355-.84.81-.84h.3V0h-.3zm1.19 0v.923h1.778V0H2.667zm2.667 0v.923h1.778V0H5.333zM8 0v.923h1.778V0H8zm2.667 0v.692h.301c.454 0 .81.37.81.841v.313h.666v-.313C12.444.69 11.78 0 10.968 0h-.301zM0 2.77v1.845h.889V2.77H0zm11.556 0v1.845h.888V2.77h-.888zM0 5.537v1.847h.889V5.538H0zm11.646 0v.853c-1.104-.524-2.325-.816-3.61-.816h-.925v1.961h.926c2.509 0 4.703 1.384 5.942 3.473H8.648c-.845 0-1.537.732-1.537 1.628v9.735c0 .895.692 1.628 1.537 1.628h13.815C23.31 24 24 23.267 24 22.372v-9.735c0-.896-.691-1.628-1.537-1.628h-6.39c-.792-1.797-2.106-3.286-3.733-4.249V5.538h-.694zM0 8.308v1.846h.889V8.308H0zm11.556.923v1.846h.888V9.23h-.888zM0 11.077v1.846h.889v-1.846H0zM8.822 12h5.57c.431.937.672 1.988.672 3.1v.312h-1.39l2.35 4.253 2.35-4.253h-1.506V15.1c0-1.088-.185-2.132-.525-3.1h5.946c.462 0 .822.377.822.859v9.36c0 .481-.36.858-.822.858H8.822c-.461 0-.822-.377-.822-.859v-9.36c0-.481.36-.858.822-.858zM0 12.923v1.846h.889v-1.846H0zm0 2.77v.312c0 .844.664 1.533 1.476 1.533h.302v-.692h-.302c-.454 0-.81-.369-.81-.84v-.314H0zm2.667.922v.923h1.777v-.923H2.667zm2.666 0v.923h1.778v-.923H5.333z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "-11 -11 44 44",
    id: "rotate-mobile"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.61 13.767c-.307.462-.805.464-1.114 0L13.651 11h1.501a3.908 3.908 0 0 0-3.903-3.903A3.908 3.908 0 0 0 7.346 11a3.908 3.908 0 0 0 3.903 3.903v1.802A5.711 5.711 0 0 1 5.545 11a5.711 5.711 0 0 1 5.704-5.705A5.711 5.711 0 0 1 16.954 11h1.501l-1.845 2.767z"
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    fill: "black",
    viewBox: "0 0 25 30",
    id: "selected-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 42 40",
    id: "sticker-size"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2,
    transform: "translate(1.5 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    x: 11,
    y: 1,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.5L27.5 3.5M.5 3.5L3.5.5",
    transform: "translate(11 31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5L3.5 3.5",
    transform: "translate(11 31) rotate(90 2 5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5L3.5 0.5",
    transform: "translate(11 31) matrix(-1 0 0 1 28 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5L3.5 3.5",
    transform: "translate(11 31) matrix(-1 0 0 1 28 0) rotate(90 2 5)"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 3.5L27.5 3.5M.5 3.5L3.5.5",
    transform: "rotate(90 3.5 4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5L3.5 3.5",
    transform: "rotate(90 3.5 4) rotate(90 2 5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5L3.5 0.5",
    transform: "rotate(90 3.5 4) matrix(-1 0 0 1 28 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5L3.5 3.5",
    transform: "rotate(90 3.5 4) matrix(-1 0 0 1 28 0) rotate(90 2 5)"
  })))))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "undo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.89 3.49a7.15 7.15 0 0 0-9 .23l-.11.1L1 2v6.12h5.89L5.25 6.41a3.84 3.84 0 0 1 2.27-.75 4.11 4.11 0 0 1 4 4.22 4.35 4.35 0 0 1-.68 2.36l-.1.14.75.75 1.78 1.77a8.1 8.1 0 0 0 1.72-5 8 8 0 0 0-3.1-6.41z",
    fill: "#052562",
    fillRule: "evenodd"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "undo-disabled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.89 3.49a7.15 7.15 0 0 0-9 .23l-.11.1L1 2v6.12h5.89L5.25 6.41a3.84 3.84 0 0 1 2.27-.75 4.11 4.11 0 0 1 4 4.22 4.35 4.35 0 0 1-.68 2.36l-.1.14.75.75 1.78 1.77a8.1 8.1 0 0 0 1.72-5 8 8 0 0 0-3.1-6.41z",
    fill: "#CACED5",
    fillRule: "evenodd"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 20",
    id: "unlocked-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.992H5.2v-3.99c-.007-1.005.526-1.936 1.395-2.44.869-.505 1.941-.505 2.81 0 .87.504 1.402 1.435 1.396 2.44v.488c0 .332.268.6.6.6.33 0 .599-.268.599-.6v-.487C12 1.792 10.21 0 8 0S4 1.792 4 4.003v3.99H2.5c-1.38 0-2.499 1.12-2.5 2.501v7.004c.001 1.381 1.12 2.5 2.5 2.502h11c1.38-.001 2.499-1.12 2.5-2.502v-7.004c-.001-1.381-1.12-2.5-2.5-2.502zm-5 7.505c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-3.002c0-.276.224-.5.5-.5s.5.224.5.5v3.002z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 392.657 392.656",
    id: "unsupported-orientation"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2,
    transform: "translate(1.5 1)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.182 62.711c15.014 21.124 21.545 46.847 18.255 73.22-.688 5.546 6.11 6.426 9.037 6.799 1.338.172 2.581.239 3.576.239 5.44 0 6.607-2.888 6.942-5.441 3.786-30.418-3.969-61.028-21.841-86.196-9.477-13.32-21.296-24.403-35.104-32.943C227.693 6.359 205.413 0 182.654 0c-30.342 0-59.412 11.15-81.855 31.375-1.042.928-3.031 1.062-4.035.306l-8.291-6.417c-3.768-2.897-7.994-2.744-10.433.019-1.023 1.176-2.161 3.347-1.683 6.923l3.414 26.564c.727 5.719 5.613 10.031 11.36 10.031l28.018-3.509c5.364-.65 6.809-3.911 7.181-5.279.373-1.377.775-4.905-3.48-8.157l-7.488-5.814-.191-1.262c18.656-16.247 42.62-25.197 67.473-25.197 19.115 0 37.82 5.336 54.076 15.415 11.618 7.23 21.535 16.553 29.462 27.713zm108.362 288.394V218.158c0-10.93-8.854-19.756-19.775-19.756H202.372v26.67h134.104c3.013 0 5.432 2.439 5.432 5.441v108.229c0 3.012-2.429 5.441-5.432 5.441H202.372v26.689H354.76c10.93.001 19.784-8.854 19.784-19.767z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.877 392.656h132.948c10.911 0 19.765-8.855 19.765-19.775V119.283c0-10.92-8.864-19.775-19.765-19.775H37.877c-10.93 0-19.766 8.855-19.766 19.775v253.598c.011 10.92 8.837 19.775 19.766 19.775zm66.144-12.078c-6.885 0-12.45-5.566-12.45-12.441s5.565-12.449 12.45-12.449c6.866 0 12.441 5.574 12.441 12.449s-5.575 12.441-12.441 12.441zM44.792 137.566c0-3.012 2.438-5.432 5.441-5.432h108.229c3.012 0 5.441 2.429 5.441 5.432v195.246c0 3.004-2.438 5.432-5.441 5.432H50.232c-3.002 0-5.441-2.428-5.441-5.432V137.566z"
  })))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 23,
    height: 21,
    xlinkHref: "#arrow-icon",
    transform: "translate(0, 0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    width: 12,
    height: 12,
    xlinkHref: "#checkmark",
    transform: "translate(0, 121)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    width: 400,
    height: 400,
    xlinkHref: "#close",
    transform: "translate(0, 233)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    width: 50,
    height: 50,
    xlinkHref: "#contract-select",
    transform: "translate(0, 733)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    width: 20,
    height: 20,
    xlinkHref: "#exclamation",
    transform: "translate(0, 883.0000000000001)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    width: 50,
    height: 50,
    xlinkHref: "#expand-select",
    transform: "translate(0, 1003)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    width: 30,
    height: 30,
    xlinkHref: "#icon-check",
    transform: "translate(0, 1153)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    width: 60,
    height: 60,
    xlinkHref: "#icon-corner-rounded",
    transform: "translate(0, 1283)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    width: 60,
    height: 60,
    xlinkHref: "#icon-corner-scalloped",
    transform: "translate(0, 1443)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    width: 60,
    height: 60,
    xlinkHref: "#icon-corner-squared",
    transform: "translate(0, 1603)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    width: 36,
    height: 36,
    xlinkHref: "#icon-easy-apply-design",
    transform: "translate(0, 1762.9999999999998)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    width: 100.7,
    height: 100.8,
    xlinkHref: "#icon-edge-scalloped",
    transform: "translate(0, 1898.9999999999998)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    width: 100.7,
    height: 100.8,
    xlinkHref: "#icon-edge-smooth",
    transform: "translate(0, 2099.8)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    width: 30,
    height: 24,
    xlinkHref: "#icon-envelope",
    transform: "translate(0, 2300.6)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    width: 36,
    height: 36,
    xlinkHref: "#icon-join-newsletter",
    transform: "translate(0, 2424.6)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    width: 25,
    height: 30,
    xlinkHref: "#icon-lock",
    transform: "translate(0, 2560.6)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    width: 36,
    height: 36,
    xlinkHref: "#icon-save-project",
    transform: "translate(0, 2690.6)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    width: 426.667,
    height: 426.667,
    xlinkHref: "#image-not-available",
    transform: "translate(0, 2826.6)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    width: 14,
    height: 14,
    xlinkHref: "#info-circle",
    transform: "translate(0, 3353.267)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    width: 32,
    height: 32,
    xlinkHref: "#label",
    transform: "translate(0, 3467.2670000000003)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    width: 60,
    height: 60,
    xlinkHref: "#loading",
    transform: "translate(0, 3599.2670000000003)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    width: 16,
    height: 20,
    xlinkHref: "#locked-icon",
    transform: "translate(0, 3759.2669999999994)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    width: 15,
    height: 15,
    xlinkHref: "#minus-icon",
    transform: "translate(0, 3879.267)"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    width: 15,
    height: 15,
    xlinkHref: "#plus-icon",
    transform: "translate(0, 3994.267)"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    width: 32,
    height: 32,
    xlinkHref: "#position",
    transform: "translate(0, 4109.267)"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    width: 16,
    height: 16,
    xlinkHref: "#redo",
    transform: "translate(0, 4241.267)"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    width: 16,
    height: 16,
    xlinkHref: "#redo-disabled",
    transform: "translate(0, 4357.267)"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    width: 22,
    height: 22,
    xlinkHref: "#resize",
    transform: "translate(0, 4473.267)"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    width: 35,
    height: 37,
    xlinkHref: "#rotate",
    transform: "translate(0, 4595.267)"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    width: 28,
    height: 25,
    xlinkHref: "#rotate-icon",
    transform: "translate(0, 4732.267)"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    width: 24,
    height: 24,
    xlinkHref: "#rotate-image-icon",
    transform: "translate(0, 4857.267)"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    width: 22,
    height: 22,
    xlinkHref: "#rotate-mobile",
    transform: "translate(0, 4981.267)"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    width: 12,
    height: 12,
    xlinkHref: "#selected-icon",
    transform: "translate(0, 5103.267)"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    width: 42,
    height: 40,
    xlinkHref: "#sticker-size",
    transform: "translate(0, 5215.267)"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    width: 16,
    height: 16,
    xlinkHref: "#undo",
    transform: "translate(0, 5355.267)"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    width: 16,
    height: 16,
    xlinkHref: "#undo-disabled",
    transform: "translate(0, 5471.267)"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    width: 16,
    height: 20,
    xlinkHref: "#unlocked-icon",
    transform: "translate(0, 5587.267)"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    width: 140,
    height: 140,
    xlinkHref: "#unsupported-orientation",
    transform: "translate(0, 5707.267)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgsprite);
export default __webpack_public_path__ + "static/media/__svgsprite.1ca8dbb0785aa7131dcb971e7636dc6a.svg";
export { ForwardRef as ReactComponent };